import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper(".js-hallSwiper", {
  // loop: true,
  spaceBetween: 5,
  slidesPerView: "auto",
  freeMode: true,
  watchSlidesProgress: true,
});

const swiper2 = new Swiper(".js-hallSwiper2", {
  loop: true,
  navigation: {
    nextEl: ".js-hallSwiper2ButtonNext",
    prevEl: ".js-hallSwiper2ButtonPrev",
  },
  pagination: {
    el: ".js-hallSwiper2 .swiper-pagination",
    type: "fraction",
  },
  spaceBetween: 0,
  thumbs: {
    swiper: swiper,
  },
});

swiper2.on('slideChange', () => {
  const index = swiper2.realIndex;
  swiper.slideTo(index);
});

const swiper3 = new Swiper(".js-hallSwiper3", {
  // loop: true,
  spaceBetween: 5,
  slidesPerView: "auto",
  freeMode: true,
  watchSlidesProgress: true,
});

const swiper4 = new Swiper(".js-hallSwiper4", {
  loop: true,
  navigation: {
    nextEl: ".js-hallSwiper2ButtonNext",
    prevEl: ".js-hallSwiper2ButtonPrev",
  },
  pagination: {
    el: ".js-hallSwiper4 .swiper-pagination",
    type: "fraction",
  },
  spaceBetween: 0,
  thumbs: {
    swiper: swiper3,
  },
});

swiper4.on('slideChange', () => {
  const index = swiper4.realIndex;
  swiper3.slideTo(index);
});

const swiper5 = new Swiper(".js-hallSwiper5", {
  // loop: true,
  spaceBetween: 5,
  slidesPerView: "auto",
  freeMode: true,
  watchSlidesProgress: true,
});

const swiper6 = new Swiper(".js-hallSwiper6", {
  loop: true,
  navigation: {
    nextEl: ".js-hallSwiper2ButtonNext",
    prevEl: ".js-hallSwiper2ButtonPrev",
  },
  pagination: {
    el: ".js-hallSwiper6 .swiper-pagination",
    type: "fraction",
  },
  spaceBetween: 0,
  thumbs: {
    swiper: swiper5,
  },
});

swiper6.on('slideChange', () => {
  const index = swiper6.realIndex;
  swiper5.slideTo(index);
});
